/**
 * Leer y escribir por ruta con puntos («seo.og.titulo», «bloques.2.titulo»), sin mutar:
 * el estado del formulario es un objeto que React compara por identidad.
 */
export const leer = (objeto: unknown, ruta: string): unknown => {
  if (!ruta) return objeto
  let actual: unknown = objeto
  for (const tramo of ruta.split('.')) {
    if (actual === null || actual === undefined) return undefined
    actual = (actual as Record<string, unknown>)[tramo]
  }
  return actual
}

export const escribir = (objeto: unknown, ruta: string, valor: unknown): unknown => {
  const tramos = ruta.split('.')
  const [cabeza, ...resto] = tramos
  if (cabeza === undefined) return valor
  const esIndice = /^\d+$/.test(cabeza)
  const contenedor: unknown = objeto ?? (esIndice ? [] : {})
  const siguiente = resto.length === 0 ? valor : escribir((contenedor as Record<string, unknown>)[cabeza], resto.join('.'), valor)
  if (Array.isArray(contenedor)) {
    const copia = [...contenedor]
    copia[Number(cabeza)] = siguiente
    return copia
  }
  return { ...(contenedor as Record<string, unknown>), [cabeza]: siguiente }
}

export const unir = (base: string, nombre?: string): string => (nombre ? (base ? `${base}.${nombre}` : nombre) : base)

/** Un identificador estable para las filas de arrays y bloques mientras se editan. */
let contador = 0
export const idDeFila = (): string => `f${Date.now().toString(36)}${(contador++).toString(36)}`
